import type { ReactNode } from 'react';

/** The one input shell for create forms — label above, control below, same metrics. */
export const field =
  'h-10 w-full rounded-[var(--radius)] border border-border bg-surface px-2 text-sm';

/**
 * A form field: its words above, the control below.
 *
 * `as="div"` is the same heading over something that is NOT one control: a loading
 * placeholder, an empty state with a link in it. A `<label>` must not wrap those, since it hands
 * its clicks to the control inside it and a retry button or a link would receive them.
 */
export function Field({
  label,
  children,
  as: Wrapper = 'label',
}: {
  label: string;
  children: ReactNode;
  as?: 'label' | 'div';
}) {
  return (
    <Wrapper className="block text-xs font-medium">
      <span className="mb-1 block text-muted-foreground">{label}</span>
      {children}
    </Wrapper>
  );
}
